import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Ellipse } from '../IconBase/IconBase'
function Clock({ color = 'icon.arrowBlue', fill = 'transparent', ...props }) {
  return (
    <IconBase viewBox='0 0 16 16' {...props}>
      <Ellipse
        cx='8.04639'
        cy='8.04639'
        rx='7.04639'
        ry='7.04639'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M11.2109 8.51647H7.57031'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M7.57115 8.51899V4.13281'
        stroke={color}
        fill={fill}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

Clock.propTypes = {
  color: PropTypes.string,
  fill: PropTypes.string,
}

export default Clock
